var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandXStyleBlack = function SvgBrandXStyleBlack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandXStyleBlack__clip0_3952_115413)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.969 10.157 22.707 0h-2.07l-7.588 8.82L6.99 0H0l9.164 13.336L0 23.988h2.07l8.013-9.314 6.4 9.314h6.989zm-2.836 3.297-.929-1.328L2.817 1.559h3.18l5.962 8.528.929 1.328 7.75 11.085h-3.181z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandXStyleBlack__clip0_3952_115413"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandXStyleBlack);
export { ForwardRef as ReactComponent };